import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import storage from 'store'
import { saveAs } from 'file-saver'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import errorCode from '@/utils/errorCode'
import { blobValidate } from '@/utils/util'

const baseURL = process.env.VUE_APP_BASE_API
let downloadLoadingInstance
export default {

  oss (ossId) {
    const token = storage.get(ACCESS_TOKEN)
    var url = baseURL + '/system/oss/download/' + ossId
    // downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: { 'Authorization': 'Bearer ' + token }
    }).then(async (res) => {
      //   const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        this.saveAs(blob, decodeURI(res.headers['download-filename']))
      } else {
        this.printErrMsg(res.data)
      }
      //   downloadLoadingInstance.close();
    }).catch((r) => {
      console.error(r)
      //   Message.error('下载文件出现错误，请联系管理员！')
      //   downloadLoadingInstance.close();
    })
  },
  /**
   * 水印图片下载
   * @param {*} ossId 文件ID
   * @param {*} text 水印文字
   * @param {*} imgurl 水印图片
   * @param {*} watermarkType 水印类型
   * @params{*} params 整个参数
   */
  ossMark (watermarkType, ossIds, text, params, imgurl) {
    const token = storage.get(ACCESS_TOKEN)
    var url = baseURL + `/system/oss/download?watermarkType=${watermarkType}&ossIds=${ossIds}&watermarkText=${text}&rentSaleType=${params.rentSaleType}`
    // downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: { 'Authorization': 'Bearer ' + token }
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data)
      if (isLogin) {
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        this.saveAs(blob, decodeURI(res.headers['download-filename']))
      } else {
        this.printErrMsg(res.data)
      }
      //   downloadLoadingInstance.close();
    }).catch((r) => {
      console.error(r)
      //   Message.error('下载文件出现错误，请联系管理员！')
      //   downloadLoadingInstance.close();
    })
  },
  zip (url, name) {
    var url = baseURL + url
    const token = storage.get(ACCESS_TOKEN)
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: { 'Authorization': 'Bearer ' + token }
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data)
      if (isLogin) {
        const blob = new Blob([res.data], { type: 'application/zip' })
        this.saveAs(blob, name)
      } else {
        this.printErrMsg(res.data)
      }
    })
  },
  saveAs (text, name, opts) {
    saveAs(text, name, opts)
  },
  async printErrMsg (data) {
    const resText = await data.text()
    const rspObj = JSON.parse(resText)
    const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
    // console.log('errMsg', errMsg)
    // notification.error({
    //   message: errMsg,
    //   duration: 5 * 1000
    // })
    message.error(errMsg)
  }
}
